import { render, staticRenderFns } from "./house-svg.vue?vue&type=template&id=cb17171a&scoped=true"
import script from "./house-svg.vue?vue&type=script&lang=js"
export * from "./house-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb17171a",
  null
  
)

export default component.exports